import { render, staticRenderFns } from "./GiftManage.vue?vue&type=template&id=70dd0c52&scoped=true"
import script from "./GiftManage.vue?vue&type=script&lang=js"
export * from "./GiftManage.vue?vue&type=script&lang=js"
import style0 from "./GiftManage.vue?vue&type=style&index=0&id=70dd0c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dd0c52",
  null
  
)

export default component.exports